import(/* webpackMode: "eager" */ "C:\\Users\\mertb\\OneDrive\\Masaüstü\\masaüstü\\kaktus\\app\\menu\\yemek\\tatli-lezzetler\\page.js");
